import React from 'react';

// Right-side drawer for the command view. Scrolls internally; the page
// behind never does. Content is whatever deep section was clicked — the
// SAME components the classic layout renders, so nothing is re-implemented.
export default function FocusDrawer({ open, title, onClose, children }) {
  return (
    <>
      <div className={`cmd-drawer-scrim ${open ? 'is-open' : ''}`} onClick={onClose} aria-hidden="true" />
      <aside className={`cmd-drawer ${open ? 'is-open' : ''}`} role="dialog" aria-modal="true" aria-label={title || 'Detail'} aria-hidden={!open}>
        <header className="cmd-drawer-head">
          <h2>{title}</h2>
          <button type="button" className="cs-btn cs-btn-sm" onClick={onClose}>Close</button>
        </header>
        <div className="cmd-drawer-body">{open ? children : null}</div>
      </aside>
    </>
  );
}
